import yup from "yup";
import qs from "query-string";
import { compose, withProps } from "recompose";
import { createStructuredSelector } from "reselect";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { createErrorsSelector } from "core/helpers";
import * as api from "modules/user/auth/api";
import * as selectors from "modules/user/auth/selectors";
import { unauthenticated } from "modules/user/auth/hoc";
import View from "./View";

export default compose(
  withRouter,
  unauthenticated,
  connect(
    createStructuredSelector({
      setPasswordApi: selectors.setPasswordApi,
      errors: createErrorsSelector(selectors.setPasswordApi)
    }),
    (dispatch, props) => ({
      onSubmit: values => {
        dispatch(
          api.setPassword.request({
            body: { ...values, ...qs.parse(props.location.search) }
          })
        );
      }
    })
  ),
  withProps({
    validationSchema: yup.object().shape({
      new_password: yup
        .string()
        .required("New password is required")
        .min(8, "Should be at least 8 characters"),
      repeat_password: yup
        .string()
        .required("Password confirmation is required")
    })
  })
)(View);



// WEBPACK FOOTER //
// ./src/components/pages/Auth/SetPass/Provider.js